/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationModel } from '../../models/configuration-model';

export interface AdminFhirIdConfigurationPost$Params {
  fhirId: string;
      body?: ConfigurationModel
}

export function adminFhirIdConfigurationPost(http: HttpClient, rootUrl: string, params: AdminFhirIdConfigurationPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdConfigurationPost.PATH, 'post');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminFhirIdConfigurationPost.PATH = '/Admin/{fhirId}/Configuration';
